import { Button, Dialog, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
// Note: '@hello-pangea/dnd' is a fork of 'react-beautiful-dnd' that is maintained for compatibility with React 18 and later.
import { styled } from '@mui/material/styles';

const OrderTasksDialog = ({ open, tasks, initialOrder, handleClickValidateOrderTasks }) => {
  const [orderedTasks, setOrderedTasks] = useState(tasks);
  const dragging = useRef(false);

  const DialogContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px',
  });

  const handleDragStart = () => {
    dragging.current = true;
  };
  const handleDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      dragging.current = false;
      return;
    }

    const updatedTasks = Array.from(orderedTasks);
    const [draggedTask] = updatedTasks.splice(source.index, 1);
    updatedTasks.splice(destination.index, 0, draggedTask);

    setOrderedTasks(updatedTasks);
    dragging.current = false;
  };

  const handleSaveOrder = () => {
    if (dragging.current) return;
    handleClickValidateOrderTasks(orderedTasks);
  };

  return (
    <Dialog open={open}>
        <DialogContent>
      <Typography variant="h5" align="center" gutterBottom>
        Tasks reorganization
      </Typography>
      <Typography variant="h8" align="center" gutterBottom>
        Drag the tasks into the desired order and click Save
      </Typography>
      <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
        <Droppable droppableId="task-list">
          {(provided) => (
            <List {...provided.droppableProps} ref={provided.innerRef}>
              {orderedTasks.map((task, index) => (
                <Draggable key={task.taskId} draggableId={`task-${task.taskId}`} index={index}>
                  {(provided) => (
                    <ListItem
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                      style={{
                        ...provided.draggableProps.style,
                        cursor: 'move',
                      }}
                    >
                      <ListItemText primary={task.name} />
                    </ListItem>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </DragDropContext>
      <Button variant="contained" color="primary" onClick={handleSaveOrder}>
        Save
      </Button>
      </DialogContent>
    </Dialog>
  );
};

// Memoize the component to prevent unnecessary re-renders due to parent component rerenders (e.g. timer updates each second)
export default React.memo(OrderTasksDialog, (prevProps, nextProps) => {
  // Only re-render if the open state or tasks change
  return prevProps.open === nextProps.open && JSON.stringify(prevProps.tasks) === JSON.stringify(nextProps.tasks);
});